import { Button } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';

bootstrapUtils.addStyle(Button, 'azure');
bootstrapUtils.addStyle(Button, 'black');
bootstrapUtils.addStyle(Button, 'splash-cta');



// WEBPACK FOOTER //
// ./src/startup/spBootstrap.js